"use strict";

exports.__esModule = true;
var _UpdateDashboardScreen = require("./UpdateDashboardScreen");
Object.keys(_UpdateDashboardScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateDashboardScreen[key]) return;
  exports[key] = _UpdateDashboardScreen[key];
});